export default __webpack_public_path__ + "static/media/BasicProgramming4.6571b6a5.png";